import constants from 'common/constants'

import {
  ADD_LEVEL,
  DELETE_LEVEL,
  GET_LEVEL,
  GET_LEVELS,
  GET_LEVELS_FOR_TIMETABLE,
  UPDATE_LEVEL,
  VIEW_LEVEL,
} from './ActionTypes/ApiActionTypes'
import {REDUX_LEVELS} from './ActionTypes/ReduxActionTypes'

export const getLevels = (data, onSuccess, onFailure) => {
  return {
    type: GET_LEVELS,
    payload: {
      apiUrl: constants.api_get_levels,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: REDUX_LEVELS,
      onSuccess,
      onFailure,
    },
  }
}

/** POST with empty JSON body — server resolves context (e.g. tenant / default branch). */
export const getLevelsForTimetable = (onSuccess, onFailure) => {
  return {
    type: GET_LEVELS_FOR_TIMETABLE,
    payload: {
      apiUrl: constants.api_get_levels_for_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: {},
      reduxActionType: REDUX_LEVELS,
      onSuccess,
      onFailure,
    },
  }
}

export const getLevel = (id, onSuccess, onFailure) => {
  return {
    type: GET_LEVEL,
    payload: {
      apiUrl: constants.api_get_level(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const addLevel = (data, onSuccess, onFailure) => {
  return {
    type: ADD_LEVEL,
    payload: {
      apiUrl: constants.api_add_level,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const updateLevel = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_LEVEL,
    payload: {
      apiUrl: constants.api_update_level(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const viewLevel = (id, onSuccess, onFailure) => {
  return {
    type: VIEW_LEVEL,
    payload: {
      apiUrl: constants.api_view_level(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const deleteLevel = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_LEVEL,
    payload: {
      apiUrl: constants.api_delete_level(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
